import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Department } from '../../models/department';
import { DepartmentService } from '../../services/department.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { DivisionService } from '../../services/division.service';
import { Division } from '../../models/division';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { LocationService } from '../../services/location.service';
import { Location } from '../../models/location';
import { ParentDepartment } from '../../models/parentdepartment';
import { ParentDepartmentService } from '../../services/parentdepartment.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerDepartment: PageHeader;
  entity: Department = new Department();
  selectedDepartment: Department = new Department();
  editingEntity: Department = new Department();
  departments: any;
  departmentColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = ''; 
  employees: Array<Employee> = [];
  selectedEmployee: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  company: Array<Company> = [];
  selectedCompany: any;
  divisions: Array<Division> = [];
  selectedDivision: any;
  locations: Array<Location> = [];
  parent_department: Array<ParentDepartment> = [];
  selectedLocation: any;
  selectedparent: any;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _departmentService: DepartmentService, 
    private _employeeService: EmployeeService,
    private _divisionService: DivisionService,
    private _companyService: CompanyService,
    private _locationService: LocationService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private _parentdepartment:ParentDepartmentService,
  ) {
    this.headerDepartment = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.departments = [];
    this.getAllDepartment();
  }
    ngAfterViewInit(): void {
    this.departmentColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 100 },
      { field: "DepartmentName", title: 'Department', filter: true, sortable: true, width: 150 },
      { field: "DepartmentPrefix", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Head', filter: true, sortable: true , width: 150},
      { field: "DeptMail", title: 'Email Id', filter: true, sortable: true, width: 100 },
      { field: "DeptPhone", title: 'Phone', filter: true, sortable: true, width: 100 },
      { field: "ParentDepartmentName", title: 'Parent Department', filter: true, sortable: true, width: 150 },
      // { field: "CompanyName", title: 'Company', filter: true, sortable: true, width: 100 },
      // { field: "DivisionName", title: 'Division', filter: true, sortable: true, width: 100 },
      // { field: "LocationName", title: 'Location', filter: true, sortable: true, width: 100 },    
      { field: "Active", title: 'Active', filter: false, sortable: true , width: 100},
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._departmentService.getAllDepartment('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Department>) => {
      this.departments = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  getAllDivisions(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.divisions = data;
    })
  }
  getAllLocations(filter: string) {
    this._locationService.getAllLocations(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Location>) => {
      this.locations = data;
    })
  }
  getAllParentDepartment(filter: string) {
    this._parentdepartment.getAllParentDepartment(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<ParentDepartment>) => {
      this.parent_department = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._departmentService.getAllDepartment(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((departments: Array<Department>) => {
        this.departments = {
          data: departments,
          total: departments[0] ? departments[0].TotalCount : 0
        }
      });
    }
  }
  getAllDepartment() {
    this._departmentService.getAllDepartment('', Number(this.defaultPageSize), 1, 0, 0).subscribe((departments: Array<Department>) => {
      this.departments = {
        data: departments,
        total: departments[0] ? departments[0].TotalCount : 0
      }
      const totalrows= departments[0].TotalCount 
      if(totalrows>10&&totalrows>50&&totalrows>100){
        this.pageSizes=  [10,50,100,totalrows] 
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._departmentService.deleteDepartment(this.selectedDepartment.Department_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearDepartment();
            this.getAllDepartment();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerDepartment = new PageHeader();
    headerDepartment.PageCaption = "Department";
    headerDepartment.IconClass = "bi bi-shield-shaded";
    return headerDepartment;
  }

  deleteDepartment(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDepartment.Department_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Department",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addDepartment(event: any) {
    this.listView = false;
    this.clearDepartment();
    this.getAllCompany('');
    this.getAllDivisions('');
    this.getAllLocations('');
    this.getAllEmployees('');
    this.getAllParentDepartment('');
    this.formCaption = "Add Department";
  }

  editDepartment(event: any): void {
    if (event.seletedRows[0]) {
      this._departmentService.viewDepartment(event.seletedRows[0]).subscribe((departments: Array<Department>) => {
        let editEnity = departments[0] ? departments[0] : new Department();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedDivision = { Division_Id: editEnity.Division_Id, DivisionName: editEnity.DivisionName };
          this.selectedLocation = { Location_Id: editEnity.Location_Id, LocationName: editEnity.LocationName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          this.selectedparent = { ParentDepartment_Id: editEnity.ParentDepartment_Id, ParentDepartmentName: editEnity.ParentDepartmentName };
         
          this.entity = { ...this.editingEntity };


          this.listView = false;
          this.formCaption = "Edit Department";
          this.getAllCompany('');
          this.getAllDivisions('');
          this.getAllLocations('');
          this.getAllEmployees('');
          this.getAllParentDepartment(''); 
          this.entity.EntityMetaData = [
            { FieldName: 'DepartmentName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Department Name is required' },
            //{ FieldName: 'Location_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Location is required' },
            { FieldName: 'DepartmentPrefix', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email Id is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Department Head is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    if(parseInt(this.entity.DepartmentPrefix)==0)
    {
      this.notification.showWarning('zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._departmentService.checkDuplication(this.entity.Department_Id,this.entity.DepartmentPrefix).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Department Code already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
            this.notification.showWarning("Invalid Phone No.");
            this.saveDisabled = false;
          }

          // const re = /^(0*[1-9]+0*)+$/;
          // const real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
          // this.codeCheck = re.test(String(this.entity.DepartmentPrefix).toString());
          // this.codealCheck = real.test(String(this.entity.DepartmentPrefix).toString());
          else{
          if (this.codealCheck == false&&this.codeCheck==false ) {
           
            this.notification.showWarning("Invalid Code!!");
            this.saveDisabled = false;
            
          }
          else {
            if (this.entity.EmailId != "") {
              // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; commented on 04-06-2024 by jessil for #I238
              const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
              if (this.emailcheck === false) {
                this.notification.showWarning("Email not valid");
                this.saveDisabled = false;
                return false;
              }
            }
              // else {
                this._departmentService.checkEmail(this.entity.EmailId, this.entity.Department_Id).subscribe((response) => {
                  if (response.Success == false) {
                    this.notification.showWarning("Email already exists");
                    this.saveDisabled = false;
                  }
                  else {
                    this._departmentService.saveDepartment(this.entity).subscribe(() => {
                      if (this.entity.Department_Id == '00000000-0000-0000-0000-000000000000') {
                        this.notification.showSuccess('Saved Successfully');
                      }
                      else {
                        this.notification.showSuccess('Updated Successfully');
                      }
                      this.listView = true;
                      this.clearDepartment();
                      this.getAllDepartment();
                    })
                  }
                });
              // }
            // }
          }
        }
        }
        return true //added on 04-06-2024 by jessil for fixing error
      });
     
    }
    else {
      this.saveDisabled = false;
    }
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllDepartment();
  }

  refreshDepartments(event: any): void {
    this.departments=[];
    this.getAllDepartment();
  }

  clearDepartment(): void {
    this.selectedLocation = {}; 
    this.selectedCompany = {}; 
    this.selectedDivision = {}; 
    this.entity = new Department();
    this.saveDisabled = false;
    this.selectedEmployee="";
    this.selectedparent="";
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.Department_Id=dataItem.Department_Id;
 this.details =[];
 this._departmentService.viewDepartment(this.entity.Department_Id).subscribe((departments: Array<Department>) => {
  this.opened = true;
  this.details = departments[0];
  })}

}
